interface CourseProgressProps {
  percent: number
  lessons: number
}

/** Низ карточки курса: сколько уроков и насколько курс пройден. */
const CourseProgress = ({ percent, lessons }: CourseProgressProps) => (
  <span className="course-progress">
    <span className="course-progress__info">
      <span>{lessons} уроков</span>
      <span>{percent}%</span>
    </span>
    <span className="course-progress__bar">
      <span
        className="course-progress__fill"
        style={{ width: `${Math.max(0, Math.min(100, percent))}%` }}
      />
    </span>
  </span>
)

export default CourseProgress
